module.exports = __webpack_public_path__ + "static/media/how_it_works_icon1.099ca67f.png";